import { format, isValid } from 'date-fns'

export const getTimeStringFromDate = (
  value: Date | string | number | undefined | null,
): string => {
  if (!value) {
    return ''
  }

  const date = new Date(value)

  if (!isValid(date)) {
    return ''
  }

  const timeStr = format(date, 'HH:mm')

  if (timeStr === '00:00' || timeStr === '23:59') {
    return ''
  }

  return timeStr
}
